
export const SKU_TABLE_HEADERS = [
  { label: 'SKU INFO', colspan: 5 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];

export const SKU_TABLE_SUB_HEADERS = [
  { label: 'NAME', key: 'itemName' },
  { label: 'ITEM TYPE', key: 'itemType' },
  { label: 'ITEM ID', key: 'itemId' },
  { label: 'CATEGORY', key: 'itemCategory' },
  { label: 'DESCRIPTION', key: 'itemDesc' },
  { label: 'PRICE', key: 'itemPrice', noTopBorder: true },
  { label: 'POINTS', key: 'pointsAmount', noTopBorder: true },
  { label: 'REDEEMABLE', key: 'redeemable', noTopBorder: true },
  { label: 'LOAD PROVIDER', key: 'provider', noTopBorder: true },
  { label: 'NETWORK PROVIDER', key: 'providerType', noTopBorder: true },
  { label: 'REBATE PERCENTAGE', key: 'rebatePercentage', noTopBorder: true },
  { label: 'SORT', key: 'sort', noTopBorder: true },
  { label: 'STATUS', key: 'status', noTopBorder: true },
  { label: 'IMAGE URL', key: 'imageUrl', noTopBorder: true },
  { label: 'ACTION', key: 'status', noTopBorder: true },
];


export const SKU_TABLE_CATEGORY_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];


export const SKU_TABLE_CATEGORY_SUBHEADERS = [
  { label: 'UID', key: 'uid', noTopBorder: true  },
  { label: 'NAME', key: 'itemCategory', noTopBorder: true },
  { label: 'DESCRIPTION', key: 'categoryDescription', noTopBorder: true },
  { label: 'IMAGE URL', key: 'imageUrl', noTopBorder: true },
  { label: 'IMAGE BANNER URL', key: 'imageBannerUrl', noTopBorder: true },
  { label: 'DATE CREATED', key: 'createDate', noTopBorder: true },
  { label: 'CREATED BY', key: 'createUser', noTopBorder: true },
  { label: 'ACTION', key: 'deleteDate', noTopBorder: true },
];

